let scrollableBlocks = [];
let prevPDPOffset = window.pageYOffset || document.documentElement.scrollTop;
let currentOffset = prevPDPOffset;

$(document).ready(() => {
  // onLoad
  scrollableBlocks = $('[data-scroll-block]');
  setTimeout(() => setStickyStyles(), 1000);

  // base funcs
  $.fn.isInViewport = function(full = false) {
    const elementTop = $(this).offset().top;
    const elementBottom = elementTop + $(this).outerHeight();

    const viewportTop = $(window).scrollTop();
    const viewportBottom = viewportTop + $(window).height();

    let inViewport;
    if (full) {
      inViewport = elementTop > viewportTop && elementBottom < viewportBottom;
    } else {
      inViewport = elementBottom > viewportTop && elementTop < viewportBottom;
    }
    return inViewport;
  };

  window.addEventListener('scroll', scrollHandler);
  $('.quick-shop-content')[0] && $('.quick-shop-content')[0].addEventListener('scroll', scrollHandler);
  function scrollHandler() {
    currentOffset = window.pageYOffset || document.documentElement.scrollTop
    homeHoneycombAnimation();
    // startHomeSlider();
    // setScrollIndicator('page-impact', 'custom-arrow-down-scroll-circles', 0.7);
    setScrollIndicator('page-about', 'custom-about-sticky');
    setScrollIndicator('page-support', 'custom-faq-gradient-block-menu', 1, false);
    setProductHeaderContent();
    triggerTypingAnimation('template-product', 'custom-product-gradient-block-body-content-item-right-typing');
    positioningProductMenu();
    if(!isDesktop()) return;

    handleGalleryIndicators()
  }

  // instagram scroll
  // if ($('.instagram-section').length > 0) {
  //   const slides = 3;

  //   $('.instagram-scroll-wrapper').scroll(function() {
  //     const scrollPercentage = 100 * $(this).scrollLeft() / (this.scrollWidth - this.clientWidth);
  //     const percentagePerSlide = 100 / slides + 0.5;
  //     const curSlide = parseInt(scrollPercentage / percentagePerSlide, 10);

  //     $('.instagram-scroll-indicators > div').removeClass('active');
  //     $($('.instagram-scroll-indicators > div')[curSlide]).addClass('active');
  //   });
  // }
});

// base
let lastItem;
let lastIndicator;
function setScrollIndicator(pageClass, containerClass, itemScale = 1, reverse = true) {
  if (!$('html').hasClass(pageClass)) return;

  const oldIndex = $(`.${containerClass} > div.active`).index();
  $(`.${containerClass} > div`).removeClass('active');
  scrollableBlocks.removeClass('in-view');

  let found = false;
  for (let i = 1; i <= scrollableBlocks.length; i++) {
    const index = reverse ? scrollableBlocks.length - i : i - 1;
    const item = $(scrollableBlocks[index]);

    if ((reverse || item.isInViewport(true)) && (item.offset().top + item.outerHeight() * itemScale < $(window).scrollTop() + $(window).height())) {
      if (isMobile && $(`.${containerClass}`).hasClass('scrollable')) {
        if (oldIndex !== index) {
          $(`.${containerClass}`).animate({
            scrollLeft: $(`.${containerClass}`).scrollLeft() + $($(`.${containerClass} > div`)[index]).position().left - 20,
          }, 400);
        }
      }
      found = true;
      lastItem = item;
      lastIndicator = $($(`.${containerClass} > div`)[index]);
      item.addClass('in-view');
      return $($(`.${containerClass} > div`)[index]).addClass('active');
    }
  }

  if (!found && lastItem) {
    lastItem.addClass('in-view');
    lastIndicator.addClass('active');
  }
}

$(document).ready(function() {
  const scrollToBlocks = [
    {
      containerClass: 'main-gallery-pagination',
      pageClass: 'template-product',
    },
    {
      containerClass: 'custom-about-sticky',
      pageClass: 'page-about',
    },
    {
      containerClass: 'custom-arrow-down-scroll-circles',
      pageClass: 'page-impact',
    },
    {
      containerClass: 'custom-faq-gradient-block-menu',
      pageClass: 'page-support',
    },
  ];

  scrollToBlocks.forEach((block) => {
    $(document).on('click',`.${block.containerClass} > div`, function() {
      if (!$('html').hasClass(block.pageClass) || (block.pageClass === 'template-product' && !isDesktop())) return;

      const index = $(this).index();
      const paddingTop = $(window).height() / 10;
      const animationTime = 1000;

      $("html, body").animate({
        scrollTop: $(scrollableBlocks[index]).offset().top - paddingTop,
      }, animationTime);
    });
  });
});

function setStickyStyles() {
  const elements = [
    {
      container: '.custom-product-gradient-block-body-menu',
      pageClass: 'template-product',
    },
  ]
  const offsetTop = `${parseInt($('header').outerHeight()) - (parseInt($('header .static-topbar').outerHeight()) || 0)}px`;

  elements.forEach((element) => {
    if (!$('html').hasClass(element.pageClass)) return;
    $(element.container).css('top', offsetTop);
  });
}

function triggerTypingAnimation(pageClass, containerClass) {
  if (!$('html').hasClass(pageClass)) return;

  const typingAnimationBlock = $($(`.${containerClass}`)[0]);
  if (typingAnimationBlock.length) {
    if (typingAnimationBlock.isInViewport()) {
      typingAnimation(typingAnimationBlock);
    }
  }
}

// common
function arrowDownLinkHangle(e) {
  if ($('html').hasClass('page-impact')) {
    e.preventDefault();
    const nextBlockIndex = $('.custom-arrow-down-scroll-circles > div.active').index() + 1;
    if (nextBlockIndex === scrollableBlocks.length) return;
    const paddingTop = $(window).height() / 10;
    const animationTime = 1000;

    $("html, body").animate({
      scrollTop: $(scrollableBlocks[nextBlockIndex]).offset().top - paddingTop,
    }, animationTime);
  }
}

// home
function homeHoneycombAnimation(heightScale = 0.5) {
  const honeycombBlock = $('.custom-home-honeycomb-block');
  if (!$('html').hasClass('template-index') || honeycombBlock.length === 0) return;

  const honeyCombAnimatedImg = $('.custom-home-honeycomb-block-animation-capsule');
  const honeyCombCapsules = $('.custom-home-honeycomb-block-animation-capsules');
  const maxTop = $('.custom-home-honeycomb-block-animation-content').outerHeight() + (isMobile ? 0 : -5);

  const trigger = $(window).scrollTop() + $(window).height() * heightScale - honeycombBlock.offset().top;
  const destination = honeyCombCapsules.offset().top - honeycombBlock.offset().top + honeyCombAnimatedImg.height() * heightScale;

  if (trigger > 0) {
    honeyCombAnimatedImg.css('margin-top', `${Math.min(trigger / destination * maxTop, maxTop)}px`)
  }
}

homeSliderStarted = false;
function startHomeSlider() {
  if (!$('html').hasClass('template-index') || homeSliderStarted) return;

  if ($('.custom-home-fill-section').isInViewport()) {
    homeSliderStarted = true;
    setTimeout(slideImgTextBtnChange, slideImgTextBtnAnimationDuration);
  }
}

// products
function setProductHeaderContent() {
  const headerSection = $('#shopify-section-cad-header');
  if (!headerSection) return;
  const impactBar = (headerSection.find('.header-wrapper .static-topbar'));
  if (!impactBar) return;

  // Hide static bar as soon as the user starts scrolling
  if (headerSection.offset().top > 50) {
    impactBar.addClass('animated-hidden');
  // Switch the topbar menu
  } else {
    impactBar.removeClass('animated-hidden');
  }

  if (!$('html').hasClass('page-the_capsule')) return;
  // Product page logic

  const offsetTop = 800;

  if (headerSection.offset().top > offsetTop) {
    headerSection.addClass('header-product-v2');
  } else {
    headerSection.removeClass('header-product-v2');
  }
}

function handleProductScrollTop() {
  const animationTime = 1000;

  $("html, body").animate({
    scrollTop: 0,
  }, animationTime);
}

function positioningProductMenu() {
  const menu = $('.custom-product-gradient-block-body-menu.scrollable');
  if (!menu.length) return;

  const elementTop = $('.custom-product-gradient-block-body-content').first().offset().top;
  const elementBottom = $('.custom-product-gradient-block-body-content').last().offset().top;
  const viewportTop = $(window).scrollTop();
  const delta = 150;

  if (elementBottom + delta > viewportTop && elementTop - delta < viewportTop) {
    menu.addClass('active');
  } else {
    menu.removeClass('active');
  }
}

function handleGalleryIndicators() {
  const pageTemplate = 'template-product';
  if (!$('html').hasClass(pageTemplate) || $('.main-gallery-pagination > div').length === 0) return;

  const container = $('.product__photos .main-gallery-pagination');
  const header = $('header');
  const lastSlide = $('.product__photos .swiper-slide').last();
  const firstSlide = $('.product__photos .swiper-slide').first();
  const dotStopPoint = lastSlide[0].getBoundingClientRect().top + lastSlide.outerHeight() / 2 - container.outerHeight()/2;
  const paginationTop = header.outerHeight() + firstSlide.outerHeight()/2;
  const currentDotPosition = container.css('position');

  if(dotStopPoint < paginationTop) {
    if (currentDotPosition === 'fixed') {
      container.css('position', 'absolute');
      container.css('top', dotStopPoint + currentOffset);
      container.css('left', '');
    }
  } else {
    if (currentDotPosition === 'absolute') {
      container.css('top', paginationTop);
      container.css('left', firstSlide.offset().left + PDP_MEDIA_NAVIGATION_LEFT_OFFSET);
      container.css('position', 'fixed');
    }
  }

  setScrollIndicator(pageTemplate, 'main-gallery-pagination');
}
